"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestCalendar = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.is-array");

var _add_months = _interopRequireDefault(require("date-fns/add_months"));

var _add_years = _interopRequireDefault(require("date-fns/add_years"));

var _is_date = _interopRequireDefault(require("date-fns/is_date"));

var _is_equal = _interopRequireDefault(require("date-fns/is_equal"));

var _sub_months = _interopRequireDefault(require("date-fns/sub_months"));

var _sub_years = _interopRequireDefault(require("date-fns/sub_years"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _propValidators = require("../utils/propValidators");

var _CalendarContent = _interopRequireDefault(require("./CalendarContent"));

var _CalendarHeader = _interopRequireDefault(require("./CalendarHeader"));

var _getNextMode = _interopRequireDefault(require("./utils/getNextMode"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getViewDate(_ref) {
  var value = _ref.value,
      defaultViewDate = _ref.defaultViewDate;

  if (defaultViewDate) {
    return defaultViewDate;
  }

  if (value) {
    return Array.isArray(value) ? value[0] : value;
  }

  return new Date();
}

function shouldUpdateViewDate(oldDate, newDate) {
  var isDifferentDate = (0, _is_date["default"])(oldDate) && !(0, _is_equal["default"])(oldDate, newDate);
  var valueWasUndefined = !(0, _is_date["default"])(oldDate) && (0, _is_date["default"])(newDate);
  return newDate && (isDifferentDate || valueWasUndefined);
}

var propTypes = {
  defaultValue: _propValidators.dateSetType,
  defaultViewDate: _propValidators.dateType,
  due: _propValidators.dateSetType,
  id: _propTypes["default"].string,
  late: _propValidators.dateSetType,
  mode: _propTypes["default"].oneOf(['month', 'year']),
  onModeChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  unavailable: _propValidators.dateSetType,
  value: _propTypes["default"].oneOfType([_propValidators.dateType, _propTypes["default"].arrayOf(_propValidators.dateType)])
};
var defaultProps = {
  defaultValue: undefined,
  value: undefined,
  mode: 'month',
  onModeChange: function onModeChange() {},
  onSelect: function onSelect() {}
};

var Calendar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Calendar, _Component);

  function Calendar(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleNext = function () {
      var mode = _this.state.mode;

      if (mode === 'month') {
        _this.setState(function (_ref2) {
          var viewDate = _ref2.viewDate;
          return {
            viewDate: (0, _add_months["default"])(viewDate, 1)
          };
        });
      } else {
        _this.setState(function (_ref3) {
          var viewDate = _ref3.viewDate;
          return {
            viewDate: (0, _add_years["default"])(viewDate, 1)
          };
        });
      }
    };

    _this.handlePeriod = function () {
      var onModeChange = _this.props.onModeChange;

      _this.setState(function (_ref4) {
        var mode = _ref4.mode;
        var nextMode = (0, _getNextMode["default"])(mode);
        onModeChange(nextMode);
        return {
          mode: nextMode
        };
      });
    };

    _this.handlePrevious = function () {
      var mode = _this.state.mode;

      if (mode === 'month') {
        _this.setState(function (_ref5) {
          var viewDate = _ref5.viewDate;
          return {
            viewDate: (0, _sub_months["default"])(viewDate, 1)
          };
        });
      } else {
        _this.setState(function (_ref6) {
          var viewDate = _ref6.viewDate;
          return {
            viewDate: (0, _sub_years["default"])(viewDate, 1)
          };
        });
      }
    };

    _this.handleSelect = function (value, event) {
      var mode = _this.state.mode;

      if (mode === 'month') {
        var onSelect = _this.props.onSelect;

        _this.setState({
          value: value
        });

        onSelect(value, event);
      } else {
        _this.setState({
          viewDate: value
        });

        _this.handlePeriod();
      }
    };

    _this.state = {
      mode: props.mode,
      value: props.value || props.defaultValue,
      viewDate: getViewDate(props)
    };
    return _this;
  }

  var _proto = Calendar.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var value = this.props.value;

    if (shouldUpdateViewDate(prevProps.value, value)) {
      this.setState({
        viewDate: value
      }); // eslint-disable-line react/no-did-update-set-state
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        due = _this$props.due,
        late = _this$props.late,
        unavailable = _this$props.unavailable,
        id = _this$props.id,
        value = _this$props.value,
        onModeChange = _this$props.onModeChange,
        defaultViewDate = _this$props.defaultViewDate,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["due", "late", "unavailable", "id", "value", "onModeChange", "defaultViewDate"]);

    var _this$state = this.state,
        mode = _this$state.mode,
        viewDate = _this$state.viewDate,
        stateValue = _this$state.value;
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
      className: "grv-calendar"
    }), /*#__PURE__*/_react["default"].createElement(_CalendarHeader["default"], {
      id: id,
      mode: mode,
      onNext: this.handleNext,
      onPeriod: this.handlePeriod,
      onPrevious: this.handlePrevious,
      viewDate: viewDate
    }), /*#__PURE__*/_react["default"].createElement(_CalendarContent["default"], {
      due: due,
      late: late,
      mode: mode,
      onSelect: this.handleSelect,
      unavailable: unavailable,
      value: typeof value !== 'undefined' ? value : stateValue,
      viewDate: viewDate
    }));
  };

  return Calendar;
}(_react.Component);

Calendar.propTypes = propTypes;
Calendar.defaultProps = defaultProps;
var TestCalendar = Calendar;
exports.TestCalendar = TestCalendar;

var _default = (0, _withId["default"])(Calendar);

exports["default"] = _default;